import Text from "@shared/components/ui-kit/typography/Text/Text.web";
import DonationsContainer from "@shared/modules/events/components/donations/DonationsContainer/DonationsContainer.web";
import { useTranslation } from "@shared/utils/internationalization";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import useCheckoutAddons from "@app-contexts/public/shared/checkout/hooks/useCheckoutAddons";

export default function DonationAddons(): JSX.Element {
  const { t } = useTranslation("checkout");
  const { charityToDisplay, isBasketUpdating, donationsEvent } =
    useCheckoutAddons();

  if (!charityToDisplay) {
    return <></>;
  }

  return (
    <Flex p={{ base: "lg", sm: "xl" }} direction="column" bg="bg">
      <Flex gap="2xs">
        <Text
          fontSize="xl"
          fontWeight="bold"
          data-testid="event-addons-donations-heading"
          ml="2xs"
        >
          {t("Add donations")}
        </Text>
        <Text fontSize="md" ml="2xs" color="gray.500" mt="2xs">
          ({t("Optional")})
        </Text>
      </Flex>
      {donationsEvent && (
        <DonationsContainer
          causeId={charityToDisplay}
          event={donationsEvent}
          isBasketUpdating={isBasketUpdating}
          useDetailedCard={false}
          hideTitle
        />
      )}
    </Flex>
  );
}
